export default "__VITE_ASSET__43825910__"